// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewMenus_root__aWqw6","active":"ViewMenus_active__b5Ey_"};